export { useMediaQuery as default } from '@crehana/react-hooks';
